import DataPackageAdapter from "../models/DataPackageAdapter";
import Portfolio from "../models/Portfolio";
import StockObjective from "../models/StockObjective";
import Transaction from "../models/Transaction";
import UserDataService from "../services/UserDataService";
import { authorizationComputed } from "../store/helpers/AuthorizationHelper";
import UserListEntryConverter from "./converters/UserListEntryConverter";

var UserDataHelperMixin = {
    data() {
        return {
            refreshInterval: 60000,
            loaded: false,
            timer: ''
        }
    },
    created() {
        this.fetchUserDataIfNeeded().then(() => {
            this.loaded = true;
        }).catch(error => { console.error(error) });
    },
    computed: {
        ...authorizationComputed,
        myData() {
            return this.$store.getters.dataPackage;
        }
    },
    methods: {
        loadDefaultUserDataPackage() {
            return new Promise((resolve) => {
                UserDataService.getDefaultUserDataPackage().then((response) => {
                    const transactions = response.transactions.map(t => new Transaction({ ...t }))
                    const stockObjectives = response.stockObjectives.map(so => new StockObjective({ ...so }));
                    this.$store.dispatch('updateAllPortfolioInfos', {
                        portfolios: response.portfolios,
                        transactions,
                        stockObjectives
                    });
                    const dataPackage = DataPackageAdapter.adaptDefault({
                        owner: 'me',
                        portfoliosTotalValue: response.portfolioSummary.portfoliosTotalValue,
                        currency: response.portfolioSummary.currency,
                        portfoliosTotalAmount: response.portfoliosTotalAmount,
                        mergedPortfolios: response.portfolioSummary.mergedPortfolios,
                        transactions: response.transactions,
                        portfoliosChangeInfo: response.portfoliosChangeInfo
                    });
                    const portfolios = response.portfolios.map(p => new Portfolio({ ...p }))
                    this.$store.dispatch('setPortfolios', { portfolios });
                    this.$store.dispatch('setObjectives', { objectives: response.objectiveProgressions });
                    this.$store.dispatch('updatePortfolioSummary', { portfolioSummary: response.portfolioSummary });
                    this.$store.dispatch('setPosition', { positions: response.userMergedStockPositions });
                    this.$store.dispatch('setMergedPositions', { mergedPositions: response.userMergedStockPositions });
                    this.$store.dispatch('updateDataPackage', { dataPackage });

                    const buyLists = response.userBuyLists.map(list => {
                        list.type = 'buy';
                        const entriesConv = list.entries.map(entry => {
                            const userListEntry = UserListEntryConverter.convert(entry);
                            userListEntry.listId = list.id;
                            return userListEntry;
                        });
                        list.entries = entriesConv;
                        return list;
                    });
                    this.$store.dispatch('setUserBuyLists', { buyLists });
                })
            });
        },
        fetchUserData() {
            return new Promise((resolve) => {
                const allPromises = [
                    this.loadDefaultUserDataPackage(),
                    this.$store.dispatch('getAllSellListWithEntries'),
                    this.$store.dispatch('getUserSubscriptionInfo'),
                    this.$store.dispatch('fetchAllPlans'),
                    this.$store.dispatch('initPreferences')
                ];
                Promise.all(allPromises)
                    .then(([dataPackage, allBuyListResult, allSellListResult, subscriptionResult, allPortfoliosResult]) => {
                        if (subscriptionResult) {
                            this.$store.dispatch('setMyPlan', { planDefinition: subscriptionResult.subscription.planDefinition })
                        }
                        resolve();
                    })
                    .catch(error => {
                        console.error(error)
                    })
            });
        },
        fetchUserDataIfNeeded() {
            return new Promise((resolve) => {
                if (!this.$store.getters.allListAreLoaded) {
                    this.loaded = false;
                    this.fetchUserData().then(() => {
                        this.loaded = true;
                        resolve();
                    });
                }
                else {
                    resolve();
                }
            });
        },
        cancelAutoUpdate() {
            clearInterval(this.timer);
        }
    },
    beforeDestroy() {
        this.cancelAutoUpdate();
    }
}

export default UserDataHelperMixin
